import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'

const FAQ = loadable(() => import('./FAQ'))
const FAQSchema = loadable(() => import('../Schema/FAQ'))

const FAQs = ({ faqs }) => (
  <div className="grid grid-cols-12 my-4">
    {faqs.map(faq => (
      <FAQ key={faq._id} question={faq.question} answer={faq.answer} />
    ))}
    <FAQSchema faqs={faqs} />
  </div>
)

export default FAQs

FAQs.propTypes = {
  faqs: PropTypes.array,
}
